<template>
  <div :class="['container', { 'pb-64': subBtnFixed }]">
    <!-- 头部 banner -->
    <div
      v-if="marketFormInfo"
      class="form-banner braft-output-content"
      v-html="marketFormInfo"
    ></div>

    <!-- 分隔 -->
    <van-divider v-if="marketFormInfo" />

    <!-- 表单内容 -->
    <van-form
      @submit="onSubmit"
      class="form-c"
      v-if="formatFormFieldListData && formatFormFieldListData.length"
    >
      <div
        class="form-item"
        v-for="(item, index) in formatFormFieldListData"
        :key="item.marketFormFieldId"
      >
        <!-- 字段名 -->
        <div
          :class="[
            'form-item-label',
            item.fieldFillRequired === 'Y' ? 'is-required' : '',
          ]"
        >
          <span>{{ item.fieldOutShow || item.fieldDescription }}</span>
          <span class="tip" v-if="item.controlType === 'CS'">【单选】</span>
          <span class="tip" v-if="item.controlType === 'MS'">【多选】</span>
        </div>
        <!-- 输入组件 -->
        <div class="form-item-field">
          <!-- 单选框类型 -->
          <template v-if="item.controlType === 'CS'">
            <!-- questionList 特殊处理 -->
            <van-field
              class="select"
              v-if="item.fieldName === 'questionList'"
              :name="`question_${index}`"
              :rules="[
                item.fieldFillRequired === 'Y'
                  ? {
                      required: true,
                      message: '请选择',
                    }
                  : { required: false },
              ]"
            >
              <template #input>
                <van-radio-group
                  v-model="formData[`question_${index}`]"
                  class="select-group"
                >
                  <van-radio
                    class="select-group-item"
                    v-for="item2 in item.options"
                    :key="item2.title"
                    :name="item2.title"
                    shape="square"
                  >
                    <div class="tit">{{ item2.title }}</div>
                    <ul class="sub-tit-list">
                      <li
                        class="sub-tit-item"
                        v-for="item3 in item2.subTitle"
                        :key="item3"
                      >
                        {{ item3 }}
                      </li>
                    </ul>
                  </van-radio>
                </van-radio-group>
              </template>
            </van-field>
            <!-- 其他 -->
            <van-field
              class="select"
              v-else
              :name="item.fieldName"
              :rules="[
                item.fieldFillRequired === 'Y'
                  ? {
                      required: true,
                      message: '请选择',
                    }
                  : { required: false },
              ]"
            >
              <template #input>
                <van-radio-group
                  v-model="formData[item.fieldName]"
                  class="select-group"
                >
                  <van-radio
                    class="select-group-item"
                    v-for="item2 in item.options"
                    :key="item2.title"
                    :name="item2.title"
                    shape="square"
                  >
                    <div class="tit">{{ item2.title }}</div>
                    <ul class="sub-tit-list">
                      <li
                        class="sub-tit-item"
                        v-for="item3 in item2.subTitle"
                        :key="item3"
                      >
                        {{ item3 }}
                      </li>
                    </ul>
                  </van-radio>
                </van-radio-group>
              </template>
            </van-field>
          </template>
          <!-- 多选框类型 -->
          <template v-else-if="item.controlType === 'MS'">
            <!-- questionList 特殊处理 -->
            <van-field
              class="select"
              v-if="item.fieldName === 'questionList'"
              :name="`question_${index}`"
              :rules="[
                item.fieldFillRequired === 'Y'
                  ? {
                      required: true,
                      message: '请选择',
                    }
                  : { required: false },
              ]"
            >
              <template #input>
                <van-checkbox-group
                  v-model="formData[`question_${index}`]"
                  class="select-group"
                >
                  <van-checkbox
                    class="select-group-item"
                    v-for="item2 in item.options"
                    :key="item2.title"
                    :name="item2.title"
                    shape="square"
                  >
                    <div class="tit">{{ item2.title }}</div>
                    <ul class="sub-tit-list">
                      <li
                        class="sub-tit-item"
                        v-for="item3 in item2.subTitle"
                        :key="item3"
                      >
                        {{ item3 }}
                      </li>
                    </ul>
                  </van-checkbox>
                </van-checkbox-group>
              </template>
            </van-field>
            <!-- 其他 -->
            <van-field
              class="select"
              v-else
              :name="item.fieldName"
              :rules="[
                item.fieldFillRequired === 'Y'
                  ? {
                      required: true,
                      message: '请选择',
                    }
                  : { required: false },
              ]"
            >
              <template #input>
                <van-checkbox-group
                  v-model="formData[item.fieldName]"
                  class="select-group"
                >
                  <van-checkbox
                    class="select-group-item"
                    v-for="item2 in item.options"
                    :key="item2.title"
                    :name="item2.title"
                    shape="square"
                  >
                    <div class="tit">{{ item2.title }}</div>
                    <ul class="sub-tit-list">
                      <li
                        class="sub-tit-item"
                        v-for="item3 in item2.subTitle"
                        :key="item3"
                      >
                        {{ item3 }}
                      </li>
                    </ul>
                  </van-checkbox>
                </van-checkbox-group>
              </template>
            </van-field>
          </template>
          <!-- 输入框类型 -->
          <template v-else>
            <!-- 手机号 -->
            <van-field
              class="inp"
              v-if="item.fieldName === 'visitorMobile'"
              v-model="formData[item.fieldName]"
              :name="item.fieldName"
              type="tel"
              :placeholder="item.fieldRemind"
              clearable
              :rules="[
                item.fieldFillRequired === 'Y'
                  ? {
                      required: true,
                      message: `请填写${item.fieldOutShow ||
                        item.fieldDescription}`,
                    }
                  : { required: false },
                {
                  validator: (value, rule) =>
                    !value || /^1[0-9]{10}$/.test(value),
                  message: '请输入正确格式',
                },
              ]"
            />
            <!-- 邮箱格式校验 -->
            <van-field
              class="inp"
              v-else-if="item.fieldName === 'visitorEmail'"
              v-model="formData[item.fieldName]"
              :name="item.fieldName"
              maxlength="100"
              :placeholder="item.fieldRemind"
              clearable
              :rules="[
                item.fieldFillRequired === 'Y'
                  ? {
                      required: true,
                      message: `请填写${item.fieldOutShow ||
                        item.fieldDescription}`,
                    }
                  : { required: false },
                {
                  validator: (value, rule) =>
                    !value ||
                    /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/.test(
                      value
                    ),
                  message: '请输入正确格式',
                },
              ]"
            />
            <!-- 电话校验 -->
            <van-field
              class="inp"
              v-else-if="item.fieldName === 'visitorPhone'"
              v-model="formData[item.fieldName]"
              :name="item.fieldName"
              type="tel"
              maxlength="100"
              :placeholder="item.fieldRemind"
              clearable
              :rules="[
                item.fieldFillRequired === 'Y'
                  ? {
                      required: true,
                      message: `请填写${item.fieldOutShow ||
                        item.fieldDescription}`,
                    }
                  : { required: false },
                {
                  validator: (value, rule) =>
                    // 不能包含中英文
                    !(value && /[a-zA-Z\u4e00-\u9fa5]+/.test(value)),
                  message: '请输入正确格式',
                },
              ]"
            />
            <!-- 咨询内容 -->
            <van-field
              class="inp"
              v-else-if="item.fieldName === 'consultContent'"
              v-model="formData[item.fieldName]"
              :name="item.fieldName"
              maxlength="200"
              type="textarea"
              :placeholder="item.fieldRemind"
              clearable
              :rules="[
                item.fieldFillRequired === 'Y'
                  ? {
                      required: true,
                      message: `请填写${item.fieldOutShow ||
                        item.fieldDescription}`,
                    }
                  : { required: false },
              ]"
            />
            <!-- 问卷题 -->
            <van-field
              class="inp"
              v-else-if="item.fieldName === 'questionList'"
              v-model="formData[`question_${index}`]"
              :name="`question_${index}`"
              maxlength="200"
              :placeholder="item.fieldRemind"
              clearable
              :rules="[
                item.fieldFillRequired === 'Y'
                  ? {
                      required: true,
                      message: `请填写`,
                    }
                  : { required: false },
              ]"
            />
            <!-- 公司全称 -->
            <div
              class="company-wrap"
              v-else-if="item.fieldName === 'visitorBelong'"
            >
              <van-field
                class="inp"
                v-model="formData['visitorBelong']"
                name="visitorBelong"
                maxlength="200"
                autocomplete="off"
                :placeholder="item.fieldRemind"
                clearable
                :border="false"
                @input="handleInputCompany"
                @focus="isShow = true"
                @blur="handlerBlur"
                :rules="
                  item.fieldFillRequired === 'Y'
                    ? [
                        {
                          required: true,
                          message: `请填写`,
                        },
                        {
                          validator: (value) => value.trim().length >= 2,
                          message: '请输入有效的公司名称',
                        },
                      ]
                    : [{ required: false }]
                "
              />
              <!-- 检索列表 -->
              <div
                class="company-list-wrap"
                ref="listWrap"
                :hidden="!isShow || !list.length"
                @mouseover="flag = true"
                @mouseout="flag = false"
              >
                <van-list
                  class="company-list"
                  v-model="loading"
                  :finished="finished"
                  finished-text="没有更多了"
                  @load="loadMore"
                  offset="100"
                >
                  <van-cell
                    class="company-item"
                    v-for="item in list"
                    :key="item.taxpayerNo"
                    :data-customer-name="item.customerName"
                    :data-taxpayer-no="item.taxpayerNo"
                    :title="item.customerName"
                    @click="selectCompany"
                  />
                </van-list>
              </div>
            </div>
            <!-- 其他 -->
            <van-field
              class="inp"
              v-else
              v-model="formData[item.fieldName]"
              :name="item.fieldName"
              maxlength="200"
              :placeholder="item.fieldRemind"
              clearable
              :rules="[
                item.fieldFillRequired === 'Y'
                  ? {
                      required: true,
                      message: `请填写${item.fieldOutShow ||
                        item.fieldDescription}`,
                    }
                  : { required: false },
              ]"
            />
          </template>
        </div>
      </div>

      <!-- 分割线 -->
      <van-divider class="form-devider" />

      <!-- 提交按钮 -->
      <div
        :class="['sub-btn', { fixed: subBtnFixed }]"
        v-if="marketFormFieldList && marketFormFieldList.length > 0"
      >
        <van-button round type="info" native-type="submit">提交</van-button>
      </div>
    </van-form>
  </div>
</template>

<script>
import { post } from '@/utils/request';

export default {
  props: {
    // 富文本框信息
    marketFormInfo: {
      type: String,
    },
    // 表单 field 列表
    marketFormFieldList: {
      type: Array,
    },
    // 底部按钮是否固定
    subBtnFixed: {
      type: Boolean,
    },
  },

  data: function() {
    return {
      formData: {},

      // 公司全称查询相关
      list: [],
      isShow: false,
      flag: false,
      loading: false,
      finished: false,
      pageSize: 20,
      pageIndex: 1,
    };
  },
  computed: {
    /**
     * 格式化表单组件数据
     */
    formatFormFieldListData: function() {
      return this.marketFormFieldList.map((item) => {
        // 单选/多选类型序列化数据，并存入options属性--(源数据为optionCode属性，其为规定格式文本)
        if (['CS', 'MS'].includes(item.controlType)) {
          const options = [];
          if (item.optionCode) {
            // 截取每个以 "[" 开头的字符串遍历
            item.optionCode.split('[').forEach((v) => {
              if (!v) return; // 空字符串跳过
              const record = {};
              // "]" 前面的内容为主要内容
              record.title = v.split(']')[0];
              record.subTitle = [];
              // "]" 后面的内容为二级标题或相关文本内容
              const subTitleStr = v.split(']')[1] || '';
              if (subTitleStr) {
                // 正则取出所有 {} 内的内容插入 subTitle 列表
                const reg = /{(.*?)}/g;
                let res;
                while ((res = reg.exec(subTitleStr))) {
                  res[1] && record.subTitle.push(res[1]);
                }
              }
              options.push(record);
            });
          }
          item.options = options;
          // console.log(options);
          return item;
        } else {
          return item;
        }
      });
    },
  },
  methods: {
    /**
     * 输入框失去焦点事件
     */
    handlerBlur: function() {
      this.isShow = this.flag;
      // 非选择失去焦点且纳税人识别号为空
      if (!this.flag && !this.formData.taxpayerNo) {
        this.formData.visitorBelong = '';
        this.list = [];
      }
    },
    /**
     * 选择公司
     */
    selectCompany: function(e) {
      const { customerName, taxpayerNo } = e.currentTarget.dataset || {};
      this.formData.visitorBelong = customerName;
      this.formData.taxpayerNo = taxpayerNo;
      this.isShow = false;
      this.flag = false;
    },
    /**
     * 公司字段输入时触发
     */
    handleInputCompany: function(value) {
      if (this.timer) clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        // 查询时--清空list、页码为1、清空纳税人识别号、滚动位置回顶部
        this.list = [];
        this.pageIndex = 1;
        this.formData.taxpayerNo = '';
        this.$refs.listWrap[0].scrollTo(0, 0);
        if (value && value.trim().length >= 2) this.queryCompany();
      }, 500);
    },
    /**
     * 加载更多
     */
    loadMore: function() {
      console.log('loadMore..');
      this.pageIndex = this.pageIndex + 1;
      this.queryCompany();
    },
    /**
     * 查询公司全称
     */
    queryCompany: function() {
      const postData = {
        customerName: this.formData.visitorBelong,
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
      };

      post('/csr/customer/searchInterface', postData).then((res) => {
        const { success, rows, total } = res || {};
        if (success) {
          const data = rows.map((v) => ({
            customerName: v.customerName,
            taxpayerNo: v.taxpayerNo,
          }));

          this.list = this.list.concat(data);
          this.finished = this.list.length >= total || this.list.length >= 100;
        }

        this.loading = false;
      });
    },
    /**
     * 清空表单
     */
    resetForm: function() {
      this.formData = {};
    },
    /**
     * 提交表单
     */
    onSubmit: function(values) {
      const questionList = [];
      // 数据处理
      this.formatFormFieldListData.map((item, index) => {
        // questionList 特殊处理
        if (item.fieldName === 'questionList') {
          let str = '';
          let value = values[`question_${index}`];
          // 多选
          if (item.controlType === 'MS') {
            value = value ? value.join(';') : '';
          }
          str += `问题：${item.fieldOutShow}    答案：${value}`;
          questionList.push(str);
        } else {
          // 其他字段--仅需处理多选类型的数据
          if (item.controlType === 'MS') {
            values[item.fieldName] = values[item.fieldName]
              ? values[item.fieldName].join(';')
              : '';
          }
        }
      });
      // questionList 输入字段--数据合并至特定格式
      if (questionList.length > 0) {
        values['questionList'] = questionList.join('\n\n');
      }

      // 纳税人代码（当选择查询到的公司时）
      values['taxpayerNo'] = this.formData.taxpayerNo || null;

      // console.log(values);
      this.$emit('handleSubmit', values);
    },
  },
};
</script>

<style lang="less" scoped>
@import '../assets/style/braft-editor.css';

.container {
  &.pb-64 {
    padding-bottom: 64px;
  }

  .form-banner {
    // border: 1px solid #ddd;
    margin: 10px 20px;
  }

  .form-c {
    // background-color: pink;
    .form-item {
      margin-bottom: 10px;
      padding: 0 20px;

      .form-item-label {
        padding: 8px 0;
        line-height: 22px;

        &.is-required::after {
          content: '*';
          display: inline;
          line-height: 100%;
          color: #ee0a24;
        }

        .tip {
          color: #999;
        }
      }

      .form-item-field {
        // 公司全称查询
        .company-wrap {
          position: relative;

          .company-list-wrap {
            width: 100%;
            max-height: 260px;
            position: absolute;
            left: 0;
            top: 100%;
            z-index: 999;
            background-color: #fff;
            border: 1px solid #ddd;
            box-shadow: 0 1px 6px rgba(0, 0, 0, 0.2);
            overflow-y: auto;
          }
        }

        // 输入框组件
        .inp {
          border: 1px solid #ddd;
          border-radius: 6px;
        }

        // 选框组件
        .select {
          padding: 0;

          .select-group {
            width: 100%;
            border: 1px solid #ddd;
            border-radius: 6px;

            .select-group-item {
              align-items: flex-start;
              padding: 16px;

              & + .select-group-item {
                border-top: 1px solid #ddd;
              }

              .sub-tit-list {
                .sub-tit-item {
                  font-size: 12px;
                  color: #999;
                  line-height: 18px;
                }
              }
            }
          }
        }
      }
    }

    .form-devider {
      margin-top: 30px;
      margin-bottom: 0;
    }

    .sub-btn {
      width: 100%;
      padding: 10px 0;
      background-color: #fff;
      text-align: center;

      &.fixed {
        position: fixed;
        left: 0;
        bottom: 0;
        border-top: 1px solid #ddd;
        background-color: rgba(255, 255, 255, 0.95);
      }

      .van-button {
        width: 80%;
        max-width: 614px;
      }
    }
  }
}
</style>
